import { withStyles } from "@material-ui/core/styles";

/**
 * Envuelve un componente ocultando .custom-card-icon y .custom-card-header
 * @param {React.Component} Component
 * @returns Componente estilizado
 */
const withCardHidingStyles = (Component) =>
    withStyles(() => ({
        root: {
            "& .custom-card-icon": {
                display: "none",
            },
            "& .custom-card-header": {
                display: "none !important",
            },
        },
    }))(Component);

export default withCardHidingStyles;
